import React, {useState, useEffect} from 'react';
import styles from './ThirdPartyInfo.css';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import {Form} from '@deere/ux.uxframe-react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import {FormattedMessage, useIntl} from 'react-intl';
import {roleMap} from '../../../mappers/translationMappers';
import PropTypes from 'prop-types';

const inputStyles = {
    inputEmailError: {
        borderStyle: 'solid',
        borderColor: '#c21020',
        borderRadius: '15px',
        marginBottom: '4px',
        backgroundColor: '#f8dedd'
    },
    inputEmailField: {
        border: '0px',
        borderRadius: '15px',
        marginBottom: '4px'
    },
    inputPhoneError: {
        borderStyle: 'solid',
        borderColor: '#c21020',
        borderRadius: '15px',
        backgroundColor: '#f8dedd',
        marginBottom: '0.1rem'
    },
    inputPhoneField: {
        border: '0px',
        borderRadius: '15px',
        marginBottom: '0.1rem'
    },
    inputRepresentativeError: {
        borderStyle: 'solid',
        borderColor: '#c21020',
        borderRadius: '15px',
        backgroundColor: '#f8dedd',
        marginBottom: '0.1rem'

    },
    inputRepresentativeField: {
        border: '0px',
        borderRadius: '15px',
        marginBottom: '0.1rem'
    }
};

const ThirdPartyInfo = (
    {
        talf_id,
        name,
        emailId,
        enabled,
        phoneNumber,
        role,
        isDuplicate,
        parentCallback,
        countryCode,
        isDuplicateEmailMobile
    }) => {
    const [enable, setEnable] = useState(true);
    const [errorPhoneNumber, setErrorPhoneNumber] = useState(false);
    const [errorEmail, setErrorEmail] = useState(false);
    const [checked, setChecked] = useState(false);
    const [signerCardCss, setSignerCardCss] = useState(styles.cardContainer);
    const intl = useIntl();
    const isESPTAssociateRole = role === 'ASSOCIATE' && (countryCode === 'ES' || countryCode === 'PT');

    function enableOrder(talf_id, e) {
        setEnable(!e.target.checked);
        setChecked(e.target.checked);
        parentCallback({tpNumber: talf_id, signer: e.target.checked, role: role});
    }


    function handleChange(talf_id, field, value) {
        if (field === 'signingMethod') {
            parentCallback({tpNumber: talf_id, signingMethod: value});
        } else if (field === 'signingOrder') {
            parentCallback({tpNumber: talf_id, signingOrder: value});
        } else if (field === 'phoneNumber') {
            if (value ? setErrorPhoneNumber(false) : setErrorPhoneNumber(true)) ;
            parentCallback({tpNumber: talf_id, phoneNumber: value});
        } else if (field === 'emailID') {
            if (value ? setErrorEmail(false) : setErrorEmail(true)) ;
            parentCallback({tpNumber: talf_id, emailID: value});
        }
    }

    useEffect(() => {
        if (checked && (isDuplicate || isDuplicateEmailMobile)) {
            setSignerCardCss(styles.cardContainerDuplicateSigner);
        } else if (checked && !isDuplicate && !isDuplicateEmailMobile) {
            setSignerCardCss(styles.cardContainerSigner);
        } else {
            setSignerCardCss(styles.cardContainer);
        }
    }, [checked, isDuplicate, isDuplicateEmailMobile]);

    useEffect(() => {
        if (isESPTAssociateRole) {
            setSignerCardCss(styles.cardContainerDisabled);
        }
    }, [role, countryCode]);

    useEffect(() => {
        setChecked(enabled)
        enableOrder(talf_id, {target: {checked: enabled}})
    }, [enabled]);

    return (
        <div
            className={signerCardCss}
            title={isESPTAssociateRole ? `${intl.formatMessage({id: 'messages.CREATE_ON_DEMAND_SIGNER_FOR_ASSOCIATE'})}` : ''}>
            <div className={styles.cardHeader}>
                <div className={styles.signerEnabled}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={checked}
                                color="primary"
                                disabled={isESPTAssociateRole}
                                id={talf_id}
                                name={talf_id}
                                onChange={(e) => enableOrder(talf_id, e)}
                            />
                        }
                        id={'signer-' + talf_id}
                        label={<span className={styles.signerLabel}><FormattedMessage id={'labels.SIGNER'}/></span>}
                        labelPlacement="end"
                    />
                </div>
                <span className={styles.role}>{role && roleMap[role.toUpperCase()]}</span>
            </div>

            <div className={styles.clr}/>

            <div className={styles.signerName}>
                <AccountCircleIcon className={styles.avatar} color="disabled"/>
                <span data-sl="mask">
                    <h6>{<strong>{name}</strong>}</h6>
                </span>
            </div>

            <section className={styles.signingActions}>
                <div className={styles.signOrder}>
                    <p>
                        <FormattedMessage id={'labels.ORDER'}/>
                    </p>
                    <Form.Control
                        as="select"
                        className="custom-select-sm border rounded"
                        disabled={enable}
                        id={'order-' + talf_id}
                        onChange={(e) =>
                            handleChange(talf_id, 'signingOrder', e.target.value)
                        }
                    >
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                    </Form.Control>
                </div>
                <div className={styles.signMethod}>
                    <p><FormattedMessage id={'labels.OPTIONS'}/></p>
                    <Form.Control
                        as="select"
                        className="custom-select-sm border rounded"
                        disabled={enable}
                        id={'method-' + talf_id}
                        onChange={(e) =>
                            handleChange(talf_id, 'signingMethod', e.target.value)
                        }
                    >
                        <option id='signByEmail' value='Sign by email'>{intl.formatMessage({id: 'labels.SIGN_BY_EMAIL'})}</option>
                        <option id='signNow' value='Sign now'>{intl.formatMessage({id: 'labels.SIGN_NOW'})}</option>
                    </Form.Control>
                </div>
            </section>
            <div
                className={isESPTAssociateRole ? styles.contactInfoDisabled : styles.contactInfo}
                title={isESPTAssociateRole ? `${intl.formatMessage({id: 'messages.CREATE_ON_DEMAND_SIGNER_FOR_ASSOCIATE'})}` : ''}>
                <Form.Group>
                    <p>
                        <FormattedMessage id={'labels.EMAIL'}/>{' '}
                        <span aria-label="required field" className="uxf-is-required">
                            *
                        </span>
                    </p>
                    <Form.Control
                        className={errorEmail ? 'border border-danger' : ''}
                        data-sl="mask"
                        defaultValue={emailId}
                        disabled={isESPTAssociateRole}
                        id={'email-' + talf_id}
                        onChange={(e) => handleChange(talf_id, 'emailID', e.target.value)}
                        required
                        size="sm"
                        style={
                            emailId
                                ? inputStyles.inputEmailField
                                : inputStyles.inputEmailError
                        }
                        type="email"
                    />
                </Form.Group>
                <Form.Group>
                    <p>
                        <FormattedMessage id={'labels.MOBILE'}/>{' '}
                        <span aria-label="required field" className="uxf-is-required">
                            *
                        </span>
                        <span aria-label="isd code required" className={styles.contactNumberHelperText}>
                            (<FormattedMessage id={'labels.ISD_CODE_IS_REQUIRED'}/>)
                        </span>
                    </p>
                    <Form.Control
                        className={errorPhoneNumber ? 'border border-danger' : ''}
                        data-sl="mask"
                        defaultValue={phoneNumber}
                        disabled={isESPTAssociateRole} id={'contact-' + talf_id}
                        onChange={(e) => handleChange(talf_id, 'phoneNumber', e.target.value)
                        } required
                        size="sm"
                        style={phoneNumber ? inputStyles.inputPhoneField : inputStyles.inputPhoneError}
                        type="text"
                    />
                    <p className={styles.contactNumberHelperText}><FormattedMessage id={'labels.EXAMPLE_PHONE_NUMBER'}/>
                    </p>
                </Form.Group>
            </div>
        </div>
    );
};
ThirdPartyInfo.propTypes = {
    countryCode: PropTypes.string,
    emailId: PropTypes.string,
    enabled: PropTypes.bool,
    isDuplicate: PropTypes.bool,
    isDuplicateEmailMobile: PropTypes.bool,
    name: PropTypes.string,
    parentCallback: PropTypes.func,
    phoneNumber: PropTypes.string,
    role: PropTypes.string,
    talf_id: PropTypes.string
}
export default ThirdPartyInfo;

const OnDemandThirdParty = (
    {
        defaultTPs,
        emailId,
        isDuplicate,
        isDuplicateEmailMobile,
        name,
        parentCallback,
        phoneNumber,
        role,
        talf_id,
        representativeFor
    }) => {
    const [enable, setEnable] = useState(true);
    const [errorPhoneNumber, setErrorPhoneNumber] = useState(false);
    const [errorEmail, setErrorEmail] = useState(false);
    const [checked, setChecked] = React.useState(true);
    const [signerCardCss, setSignerCardCss] = useState(styles.cardContainer);
    const [errorThirdParty, setErrorThirdParty] = useState(false);
    const intl = useIntl();

    function enableOrder(talf_id, e) {
        setEnable(!e.target.checked);
        setChecked(e.target.checked);
        parentCallback({tpNumber: talf_id, signer: e.target.checked, role: role});
    }

    function handleChange(talf_id, field, value) {
        if (field === 'signingMethod') {
            parentCallback({tpNumber: talf_id, signingMethod: value});
        } else if (field === 'signingOrder') {
            parentCallback({tpNumber: talf_id, signingOrder: value});
        } else if (field === 'phoneNumber') {
            if (value ? setErrorPhoneNumber(false) : setErrorPhoneNumber(true)) ;
            parentCallback({tpNumber: talf_id, phoneNumber: value});
        } else if (field === 'emailID') {
            if (value ? setErrorEmail(false) : setErrorEmail(true)) ;
            parentCallback({tpNumber: talf_id, emailID: value});
        } else if (field === 'representativeFor') {
            if (value ? setErrorThirdParty(false) : setErrorThirdParty(true)) ;
            parentCallback({tpNumber: talf_id, representativeFor: value});
        }
    }

    useEffect(() => {
        if (checked && (isDuplicate|| isDuplicateEmailMobile)) {
            setSignerCardCss(styles.cardContainerDuplicateSigner);
        } else if (checked && (!isDuplicate && !isDuplicateEmailMobile)) {
            setSignerCardCss(styles.cardContainerSigner);
        } else {
            setSignerCardCss(styles.cardContainer);
        }
    }, [checked, isDuplicate, isDuplicateEmailMobile]);

    const filteredThirdParties = (defaultTPs || []).filter(thirdParty =>
        thirdParty.role !== 'GUARANTOR' && thirdParty.role !== 'ASSOCIATE' && thirdParty.thirdPartyClass !== 'Individual'
    );


    return (
        <div className={signerCardCss}>
            <div className={styles.cardHeader}>
                <div className={styles.signerEnabled}>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={checked}
                                color="primary"
                                id={talf_id}
                                name={talf_id}
                                onChange={(e) => enableOrder(talf_id, e)}
                            />
                        }
                        id={'signer-' + talf_id}
                        label={<span className={styles.signerLabel}><FormattedMessage id={'labels.SIGNER'}/></span>}
                        labelPlacement="end"
                    />
                </div>
                <span className={styles.role}>{role && roleMap[role.toUpperCase()]}</span>
            </div>

            <div className={styles.clr}/>

            <div className={styles.signerName}>
                <AccountCircleIcon className={styles.avatar} color="disabled"/>
                <span data-sl="mask">
                    <h6>{<strong>{name}</strong>}</h6>
                </span>
            </div>

            <section className={styles.signingActions}>
                <div className={styles.signOrder}>
                    <p className={styles.signOrderLabel}><FormattedMessage id={'labels.ORDER'}/></p>
                    <Form.Control
                        as="select"
                        className="custom-select-sm border rounded"
                        disabled={enable}
                        id={'order-' + talf_id}
                        onChange={(e) =>
                            handleChange(talf_id, 'signingOrder', e.target.value)
                        }
                    >
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5</option>
                    </Form.Control>
                </div>
                <div className={styles.signMethod}>
                    <p className={styles.signMethodLabel}>
                        <FormattedMessage id={'labels.OPTIONS'}/>
                    </p>
                    <Form.Control
                        as="select"
                        className="custom-select-sm border rounded"
                        disabled={enable}
                        id={'method-' + talf_id}
                        onChange={(e) =>
                            handleChange(talf_id, 'signingMethod', e.target.value)
                        }
                    >
                        <option value='Sign by email'>{intl.formatMessage({id: 'labels.SIGN_BY_EMAIL'})}</option>
                        <option value='Sign now'>{intl.formatMessage({id: 'labels.SIGN_NOW'})}</option>
                    </Form.Control>
                </div>
            </section>
            <div className={styles.contactInfo}>
                <Form.Group>
                    <p className={styles.emailLabel}><FormattedMessage id={'labels.EMAIL'}/>{' '}<span
                        aria-label="required field" className="uxf-is-required">*</span></p>
                    <Form.Control
                        className={errorEmail ? 'border border-danger' : ''}
                        data-sl="mask"
                        defaultValue={emailId}
                        id={'email-' + talf_id}
                        onChange={(e) => handleChange(talf_id, 'emailID', e.target.value)} required size="sm"
                        style={emailId ? inputStyles.inputEmailField : inputStyles.inputEmailError}
                        type="email"
                    />
                </Form.Group>
                <Form.Group>
                    <p>
                        <FormattedMessage id={'labels.MOBILE'}/>{' '}
                        <span aria-label="required field" className="uxf-is-required">
                            *
                        </span>
                        <span aria-label="isd code required" className={styles.contactNumberHelperText}>
                            (<FormattedMessage id={'labels.ISD_CODE_IS_REQUIRED'}/>)
                        </span>
                    </p>
                    <Form.Control
                        className={errorPhoneNumber ? 'border border-danger' : ''}
                        data-sl="mask"
                        defaultValue={phoneNumber}
                        id={'contact-' + talf_id} onChange={(e) => handleChange(talf_id, 'phoneNumber', e.target.value)}
                        required size="sm"
                        style={phoneNumber ? inputStyles.inputPhoneField : inputStyles.inputPhoneError}
                        type="text"
                    />
                    <p className={styles.contactNumberHelperText}><FormattedMessage id={'labels.EXAMPLE_PHONE_NUMBER'}/>
                    </p>
                </Form.Group>
                {representativeFor && (
                    <Form.Group >
                        <p className={styles.odSignerInputLabel}>
                            <FormattedMessage id={'labels.THIRD_PARTY'} />
                            <span aria-label="required field" className="uxf-is-required">
                                *
                            </span>
                        </p>
                        <Form.Control as="select"
                            className={errorThirdParty? 'border border-danger' : ''}
                            data-sl="mask"
                            disabled={false}
                            id={`thirdPartySelect-${talf_id}`}
                            onChange={(e) => handleChange(talf_id, 'representativeFor', e.target.value)} required
                            size="sm"
                            style={representativeFor ? inputStyles.inputRepresentativeField : inputStyles.inputRepresentativeError}
                            value={representativeFor}
                        >
                            {filteredThirdParties.map((thirdParty, index) => (
                                <option key={index} style={{ whiteSpace: 'normal', wordWrap: 'break-word' }} value={`${thirdParty.tpNumber}-${thirdParty.role}`}>
                                    {thirdParty.name} - {thirdParty.tpNumber}
                                </option>
                            ))}
                        </Form.Control>


                    </Form.Group>
                )}
            </div>

        </div>
    );
};

OnDemandThirdParty.propTypes = {
    emailId: PropTypes.string,
    isDuplicate: PropTypes.bool,
    isDuplicateEmailMobile: PropTypes.bool,
    name: PropTypes.string,
    parentCallback: PropTypes.func,
    phoneNumber: PropTypes.string,
    role: PropTypes.string,
    talf_id: PropTypes.string,
    representativeFor: PropTypes.string,
    defaultTPs: PropTypes.arrayOf(PropTypes.object)
}

export { OnDemandThirdParty };
